import { Idx, IIdx } from "./IIdx";

export class idx_api {

    public static update_idx:string = "/api/idx/update";
    public static find_by_id:string = "/api/idx/find_by_id";
    public static get_by_wytwor_idm:string ="/api/erp/idx/get_by_wytwor_idm"

    public static create_nowy_w_erp:string = "/api/idx/create_nowy_w_erp"
    public static create_korekta_w_erp:string = "/api/idx/create_korekta_w_erp"
    public static update_w_erp:string = "/api/idx/update_w_erp"

    public static create_nowy_w_erp_full:string = "/api/idx/create_nowy_w_erp_full"
    public static create_korekta_w_erp_full:string = "/api/idx/create_korekta_w_erp_full"


}

export interface IIdxSvc {

    update_idx(idx: IIdx): Promise<IIdx | undefined> 
    find_by_id(_id: any): Promise<IIdx | undefined> 
    create_nowy_w_erp(idx: IIdx): Promise<IIdx | undefined> 
    update_w_erp(idx: IIdx): Promise<IIdx | undefined> 
    create_korekta_w_erp(idx: IIdx): Promise<IIdx | undefined> 
    get_by_wytwor_idm(nr_etykiety: string):Promise<IIdx | undefined> ;

    create_nowy_w_erp_full(idx: IIdx): Promise<IIdx | undefined> 
    create_korekta_w_erp_full(idx: IIdx): Promise<IIdx | undefined> 
    
}